// import external dependencies
import 'jquery';
import 'jquery-migrate';

// Import everything from autoload
import './autoload/_bootstrap.js';

import Router from './util/Router';

import 'vimeo-froogaloop2';
import 'slick-carousel';

import common from './routes/common';
import home from './routes/home';
import blog from './routes/blog';
import data from './routes/data';
import vetsAdvocacy from './routes/vets_advocacy';
import masterplan from './routes/masterplan';
import contact from './routes/contact';
import pledge from './routes/pledge';
import reportCard from './routes/report_card';
import losAngelesCountyVeteranHomelessnessDashboard from './routes/los_angeles_county_veteran_homelessness_dashboard';
import thankYou from './routes/thank_you';
import housing from './routes/housing';
import singleLocations from './routes/single_locations';
import aboutUs from './routes/about_us';
import register from './routes/register';

//** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  blog,
  data,
  vetsAdvocacy,
  masterplan,
  contact,
  pledge,
  reportCard,
  losAngelesCountyVeteranHomelessnessDashboard,
  thankYou,
  housing,
  singleLocations,
  aboutUs,
  register,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js